import * as Sentry from '@sentry/react';

const parseSampleRate = (value: string | undefined, fallback: number) => {
  if (!value) {
    return fallback;
  }

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  const tracesSampleRate = parseSampleRate(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    1,
  );
  const replaysSessionSampleRate = parseSampleRate(
    import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    0,
  );
  const replaysErrorSampleRate = parseSampleRate(
    import.meta.env.VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE,
    1,
  );

  const integrations = [
    Sentry.browserTracingIntegration(),
    ...(replaysSessionSampleRate > 0 || replaysErrorSampleRate > 0
      ? [Sentry.replayIntegration()]
      : []),
  ];

  Sentry.init({
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    integrations,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate: replaysErrorSampleRate,
  });
}
